console.log('Bundle removal script caricato');


// TRADUZIONI INTEGRATE
const bundleTranslations = {
    'it': {
        modal_title: 'Rimozione Anello Solitario',
        modal_main_text: 'Stai rimuovendo parte di un anello solitario personalizzato.',
        modal_description: 'Montatura e diamante sono mostrati separatamente per maggiore chiarezza sui singoli prezzi, ma formano un unico prodotto.',
        modal_warning: 'Continuando, <strong>l\'intero anello verrà rimosso</strong> dal carrello.',
        cancel_button: 'Annulla',
        confirm_button: 'Rimuovi',
        quantity_message: 'Quantità: 1',
        fixed_quantity_tooltip: 'Quantità fissa per anello solitario'
    },
    'en': {
        modal_title: 'Solitaire Ring Removal',
        modal_main_text: 'You are removing part of a custom solitaire ring.',
        modal_description: 'Setting and diamond are shown separately for greater clarity on individual prices, but they form a single product.',
        modal_warning: 'Continuing, <strong>the entire ring will be removed</strong> from the cart.',
        cancel_button: 'Cancel',
        confirm_button: 'Remove',
        quantity_message: 'Quantity: 1',
        fixed_quantity_tooltip: 'Fixed quantity for solitaire ring'
    }
};

// Funzione per ottenere la lingua corrente
function getCurrentLanguage() {
    // Prova prima con Shopify.locale se disponibile
    if (typeof Shopify !== 'undefined' && Shopify.locale) {
        return Shopify.locale;
    }
    
    // Fallback all'attributo lang dell'HTML
    const htmlLang = document.documentElement.lang;
    if (htmlLang) {
        return htmlLang.split('-')[0]; // Es: 'en-US' -> 'en'
    }
    
    // Fallback finale all'italiano
    return 'it';
}

// Funzione per ottenere una traduzione
function getTranslation(key, fallback = '') {
    const currentLang = getCurrentLanguage();
    
    // Prova con la lingua corrente
    if (bundleTranslations[currentLang] && bundleTranslations[currentLang][key]) {
        return bundleTranslations[currentLang][key];
    }
    
    // Fallback all'italiano
    if (bundleTranslations['it'] && bundleTranslations['it'][key]) {
        return bundleTranslations['it'][key];
    }
    
    // Fallback finale
    return fallback;
}

console.log('Lingua rilevata:', getCurrentLanguage());





document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM ready - Bundle script attivo');
    
    // Intercettiamo in CAPTURE PHASE (prima di tutti gli altri)
    document.addEventListener('click', function(e) {
        const button = e.target.closest('.ajaxcart__remove') || 
                      e.target.closest('.cart-product-info__btn--remove');
        
        if (button) {
            const line = button.getAttribute('data-line');
            
            console.log('*** INTERCETTATO IN CAPTURE PHASE ***');
            console.log('- Line:', line);
            
            // BLOCCHIAMO IMMEDIATAMENTE
            e.preventDefault();
            e.stopImmediatePropagation();
            
            // Disabilitiamo temporaneamente il bottone
            button.disabled = true;
            button.style.opacity = '0.5';
            button.style.pointerEvents = 'none';
            
            console.log('Bottone disabilitato, inizio controllo bundle...');
            
            // Controlliamo se è un bundle
            checkIfBundle(line, button);
        }
    }, true); // TRUE = capture phase
    
    function checkIfBundle(line, originalButton) {
        console.log('Controllo bundle per line:', line);
        
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const itemIndex = parseInt(line) - 1;
                const item = cart.items[itemIndex];
                
                if (!item) {
                    console.log('Item non trovato');
                    restoreButton(originalButton);
                    proceedWithNormalRemoval(line);
                    return;
                }
                
                console.log('Item:', item.product_title);
                console.log('Properties:', item.properties);
                
                if (isBundleItem(item)) {
                    console.log('*** È UN BUNDLE! ***');
                    const associatedItem = findAssociatedItem(cart.items, item, parseInt(line));
                    
                    if (associatedItem) {
                        console.log('*** TROVATO ITEM ASSOCIATO ***');
                        console.log('- Item 1:', item.product_title, '(Componente:', item.properties['Componente'] + ')');
                        console.log('- Item 2:', associatedItem.product_title, '(Componente:', associatedItem.properties['Componente'] + ')');
                        
                        // Per ora chiediamo conferma con alert (poi faremo modal)
                        restoreButton(originalButton);
                        showSimpleConfirm(item, associatedItem, line, associatedItem.lineIndex);
                    } else {
                        console.log('Nessun item associato, rimozione normale');
                        restoreButton(originalButton);
                        proceedWithNormalRemoval(line);
                    }
                } else {
                    console.log('Non è un bundle, rimozione normale');
                    restoreButton(originalButton);
                    proceedWithNormalRemoval(line);
                }
            })
            .catch(error => {
                console.error('Errore:', error);
                restoreButton(originalButton);
                proceedWithNormalRemoval(line);
            });
    }
    
    function isBundleItem(item) {
        if (!item.properties) return false;
        
        const hasComponente = item.properties['Componente'] === 'Montatura' || 
                             item.properties['Componente'] === 'Diamante';
        const hasAbbinato = item.properties['Abbinato_a'] && 
                           item.properties['Abbinato_a'].trim() !== '';
        
        return hasComponente && hasAbbinato;
    }
    
    function findAssociatedItem(cartItems, currentItem, currentLine) {
        const currentComponent = currentItem.properties['Componente'];
        const targetComponent = currentComponent === 'Montatura' ? 'Diamante' : 'Montatura';
        
        for (let i = 0; i < cartItems.length; i++) {
            const item = cartItems[i];
            const itemLine = i + 1;
            
            if (itemLine === currentLine) continue;
            
            if (item.properties && 
                item.properties['Componente'] === targetComponent &&
                item.properties['Abbinato_a']) {
                
                return {
                    ...item,
                    lineIndex: itemLine
                };
            }
        }
        
        return null;
    }
    
   function showSimpleConfirm(item1, item2, line1, line2) {
    // Creiamo il modal HTML
    const modalHTML = `
        <div id="bundle-removal-modal" class="bundle-modal-overlay">
            <div class="bundle-modal-content">
                <div class="bundle-modal-header">
                    <h3>${getTranslation('modal_title')}</h3>
                    <button class="bundle-modal-close">&times;</button>
                </div>
                <div class="bundle-modal-body">
                    <p><strong>${getTranslation('modal_main_text')}</strong><br>
                    ${getTranslation('modal_description')}<br>
                    ${getTranslation('modal_warning')}</p>
                    <div class="bundle-items-preview">
                        <div class="bundle-item">
                            <img src="${getItemImage(item1)}" alt="${item1.product_title}">
                            <div class="bundle-item-info">
                                <h4>${item1.product_title}</h4>
                                <p>${item1.properties['Componente']} - ${formatPrice(item1.final_line_price)}</p>
                            </div>
                        </div>
                        <div class="bundle-item">
                            <img src="${getItemImage(item2)}" alt="${item2.product_title}">
                            <div class="bundle-item-info">
                                <h4>${item2.product_title}</h4>
                                <p>${item2.properties['Componente']} - ${formatPrice(item2.final_line_price)}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bundle-modal-footer">
                    <button class="bundle-btn bundle-btn-cancel">${getTranslation('cancel_button')}</button>
                    <button class="bundle-btn bundle-btn-confirm">${getTranslation('confirm_button')}</button>
                </div>
            </div>
        </div>
    `;
    
    // Aggiungiamo il modal al DOM
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    const modal = document.getElementById('bundle-removal-modal');
    
    // Event listeners
    modal.querySelector('.bundle-modal-close').addEventListener('click', closeModal);
    modal.querySelector('.bundle-btn-cancel').addEventListener('click', closeModal);
    modal.querySelector('.bundle-btn-confirm').addEventListener('click', function() {
        closeModal();
        removeBothItems(line1, line2);
    });
    
    // Chiudi cliccando l'overlay
    modal.addEventListener('click', function(e) {
        if (e.target === modal) {
            closeModal();
        }
    });
    
    function closeModal() {
        modal.remove();
    }
}

// Funzioni helper
function getItemImage(item) {
    if (item.image) {
        return item.image.replace(/(\.[^.]*)$/, "_120x$1");
    }
    return "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
}

function formatPrice(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
}
    
    function removeBothItems(line1, line2) {
        console.log('Rimozione di entrambi gli items:', line1, line2);
        
        // Rimuoviamo prima il line number più alto per non alterare gli indici
        const firstLine = Math.max(line1, line2);
        const secondLine = Math.min(line1, line2);
        
        // Chiamiamo l'API di Shopify per rimuovere
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `quantity=0&line=${firstLine}`
        })
        .then(() => {
            return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: `quantity=0&line=${secondLine}`
            });
        })
        .then(() => {
            console.log('Entrambi gli items rimossi, ricarico carrello');
            location.reload(); // Ricarica la pagina per aggiornare il carrello
        })
        .catch(error => {
            console.error('Errore nella rimozione:', error);
            location.reload(); // Ricarica comunque in caso di errore
        });
    }
    
    function proceedWithNormalRemoval(line) {
        console.log('Rimozione normale per line:', line);
        
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `quantity=0&line=${line}`
        })
        .then(() => {
            console.log('Item rimosso, ricarico carrello');
            location.reload();
        })
        .catch(error => {
            console.error('Errore rimozione:', error);
            location.reload();
        });
    }
    
    function restoreButton(button) {
        button.disabled = false;
        button.style.opacity = '';
        button.style.pointerEvents = '';
    }
    
    // Chiamata iniziale
    setTimeout(handleBundleQuantities, 2000);

    // Intercetta apertura drawer e aggiunta prodotti
    interceptDrawerEvents();

   // Intercetta click quantità
    interceptQuantityClicks();

    // AGGIUNGI QUESTA RIGA
    interceptEditModal();

    console.log('Event listener configurato in capture phase');
});


// Funzione per gestire la quantità dei bundle - CON DEBUG
function handleBundleQuantities() {
    console.log('=== CONTROLLO QUANTITÀ E RIMOZIONE ICONE MODIFICA ===');
    
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            cart.items.forEach((item, index) => {
                const line = index + 1;
                
                // Controlla se è bundle
                const isDirectBundle = isBundleItemGlobal(item);
                const bundleAssociation = findBundleAssociation(cart.items, item, index);
                const isBundle = isDirectBundle || bundleAssociation.isBundle;
                
                if (isBundle) {
                    console.log('Bundle trovato:', item.product_title, 'line:', line);
                    hideBundleQuantityControls(line);
                }
                
                // NASCONDI ICONA MODIFICA PER TUTTI I PRODOTTI
                hideAllEditIcons(line);
            });
        })
        .catch(error => {
            console.error('Errore:', error);
        });
}


// Funzione per nascondere icona di modifica per TUTTI i prodotti
function hideAllEditIcons(line) {
    console.log('Nascondo icona modifica per line:', line);
    
    // Selettori per PAGINA CARRELLO
    const editButton = document.querySelector(`.item-cart[data-line="${line}"] .cart-product-edit_variant`);
    const editIcon = document.querySelector(`.item-cart[data-line="${line}"] .cart-product-info__btn--edit`);
    
    // Selettori per DRAWER
    const drawerEditButton = document.querySelector(`.ajaxcart__product[data-line="${line}"] .cart-product-edit_variant`);
    const drawerEditIcon = document.querySelector(`.ajaxcart__product[data-line="${line}"] .cart-product-info__btn--edit`);
    
    // Nascondi nel carrello
    if (editButton) {
        editButton.style.display = 'none';
    }
    
    if (editIcon) {
        editIcon.style.display = 'none';
    }
    
    // Nascondi nel drawer
    if (drawerEditButton) {
        drawerEditButton.style.display = 'none';
    }
    
    if (drawerEditIcon) {
        drawerEditIcon.style.display = 'none';
    }
    
    // Nasconde tutte le icone matita/edit
    const allEditButtons = document.querySelectorAll(
        `.item-cart[data-line="${line}"] button[data-handle], ` +
        `.item-cart[data-line="${line}"] a[data-handle], ` +
        `.ajaxcart__product[data-line="${line}"] button[data-handle], ` +
        `.ajaxcart__product[data-line="${line}"] a[data-handle], ` +
        `.item-cart[data-line="${line}"] .edit, ` +
        `.ajaxcart__product[data-line="${line}"] .edit`
    );
    
    allEditButtons.forEach(button => {
        button.style.display = 'none';
    });
    
    console.log('Tutte le icone modifica nascoste per line:', line);
}

function hideBundleQuantityControls(line) {
    console.log('Nascondo controlli per line:', line);
    
    // Rimuovi messaggi esistenti per evitare duplicati
    const existingMessages = document.querySelectorAll(`.bundle-qty-message[data-line="${line}"]`);
    existingMessages.forEach(msg => {
        console.log('Rimuovo messaggio esistente per line:', line);
        msg.remove();
    });
    
    // Selettori per drawer
    const drawerQuantity = document.querySelector(`.ajaxcart__product[data-line="${line}"] .ajaxcart__qty`);
    
    // Selettori per pagina carrello
    const cartQuantityContainer = document.querySelector(`.item-cart[data-line="${line}"] .quantity-content`);
    const cartQuantityInputs = document.querySelectorAll(`.item-cart[data-line="${line}"] input[type="text"], .item-cart[data-line="${line}"] button`);
    
    console.log('Drawer quantity trovato:', !!drawerQuantity);
    console.log('Cart quantity container trovato:', !!cartQuantityContainer);
    
    // Nascondi controlli drawer E aggiungi messaggio
    if (drawerQuantity) {
        drawerQuantity.style.display = 'none';
        
        // DISABILITA TUTTI GLI INPUT NEL DRAWER PER QUESTA LINE
        const drawerInputs = document.querySelectorAll(`.ajaxcart__product[data-line="${line}"] input, .ajaxcart__product[data-line="${line}"] button.ajaxcart__qty-adjust`);
        drawerInputs.forEach(input => {
            input.disabled = true;
            input.style.opacity = '0.3';
            input.style.cursor = 'not-allowed';
            input.title = getTranslation('fixed_quantity_tooltip');
        });
        
        // Aggiungi sempre il messaggio per drawer
        const drawerMessage = document.createElement('div');
        drawerMessage.className = 'bundle-qty-message';
        drawerMessage.setAttribute('data-line', line);
        drawerMessage.innerHTML = `<small style="color: #666; font-style: italic;">${getTranslation('quantity_message')}</small>`;
        drawerQuantity.parentNode.insertBefore(drawerMessage, drawerQuantity);
        
        console.log('Input drawer disabilitati e messaggio aggiunto per line:', line);
    }
    
    // Nascondi controlli pagina carrello E aggiungi messaggio
    if (cartQuantityContainer) {
        cartQuantityContainer.style.display = 'none';
        
        // DISABILITA TUTTI GLI INPUT NELLA PAGINA CARRELLO PER QUESTA LINE  
        const cartInputs = document.querySelectorAll(`.item-cart[data-line="${line}"] input, .item-cart[data-line="${line}"] button.js-qty-adjust`);
        cartInputs.forEach(input => {
            input.disabled = true;
            input.style.opacity = '0.3';
            input.style.cursor = 'not-allowed';
            input.title = getTranslation('fixed_quantity_tooltip');
        });
        
        // Aggiungi sempre il messaggio per carrello
        const cartMessage = document.createElement('div');
        cartMessage.className = 'bundle-qty-message';
        cartMessage.setAttribute('data-line', line);
        cartMessage.style.textAlign = 'center';
        cartMessage.style.padding = '10px';
        cartMessage.innerHTML = '<span style="font-size: 16px; color: #333; padding:5px;">1</span>';
        cartQuantityContainer.parentNode.insertBefore(cartMessage, cartQuantityContainer);
        
        console.log('Input carrello disabilitati e messaggio aggiunto per line:', line);
    } else if (cartQuantityInputs.length > 0) {
        // Fallback per pagina carrello
        cartQuantityInputs.forEach(input => {
            input.style.display = 'none';
            input.disabled = true;
            input.style.opacity = '0.3';
            input.style.cursor = 'not-allowed';
            input.title = getTranslation('fixed_quantity_tooltip');
        });
        
        const parent = cartQuantityInputs[0].closest('td') || cartQuantityInputs[0].parentElement;
        if (parent) {
            const cartMessage = document.createElement('div');
            cartMessage.className = 'bundle-qty-message';
            cartMessage.setAttribute('data-line', line);
            cartMessage.style.textAlign = 'center';
            cartMessage.innerHTML = '<span style="font-size: 16px; color: #333;">1</span>';
            parent.appendChild(cartMessage);
            console.log('Fallback: messaggio carrello aggiunto per line:', line);
        }
    }
}

// Aggiungi questa funzione DOPO hideBundleQuantityControls e PRIMA degli stili CSS
function observeCartChanges() {
    // Osserva cambiamenti nel DOM del carrello
    const cartObserver = new MutationObserver(function(mutations) {
        let cartChanged = false;
        
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                cartChanged = true;
            }
        });
        
        if (cartChanged) {
            setTimeout(handleBundleQuantities, 500);
        }
    });
    
    // Osserva sia drawer che pagina carrello
    const drawer = document.querySelector('.js-drawer');
    const cartPage = document.querySelector('[data-cartpage-container]');
    
    if (drawer) {
        cartObserver.observe(drawer, { childList: true, subtree: true });
    }
    
    if (cartPage) {
        cartObserver.observe(cartPage, { childList: true, subtree: true });
    }
}

function isBundleItem(item) {
    if (!item.properties) return false;
    
    const hasComponente = item.properties['Componente'] === 'Montatura' || 
                         item.properties['Componente'] === 'Diamante';
    const hasAbbinato = item.properties['Abbinato_a'] && 
                       item.properties['Abbinato_a'].trim() !== '';
    
    return hasComponente && hasAbbinato;
}

// Funzione isBundleItem GLOBALE
// Funzione isBundleItem GLOBALE - VERSIONE MIGLIORATA
function isBundleItemGlobal(item) {
    if (!item.properties) return false;
    
    // Caso 1: Ha direttamente le properties del bundle
    const hasComponente = item.properties['Componente'] === 'Montatura' || 
                         item.properties['Componente'] === 'Diamante';
    const hasAbbinato = item.properties['Abbinato_a'] && 
                       item.properties['Abbinato_a'].trim() !== '';
    
    if (hasComponente && hasAbbinato) {
        return true;
    }
    
    return false;
}

// Nuova funzione per riconoscere bundle tramite associazione
function findBundleAssociation(cartItems, currentItem, currentIndex) {
    const currentTitle = currentItem.product_title;
    
    // Cerca se c'è un diamante che fa riferimento a questo prodotto
    for (let i = 0; i < cartItems.length; i++) {
        if (i === currentIndex) continue; // Salta se stesso
        
        const otherItem = cartItems[i];
        
        // Se l'altro item è un diamante che fa riferimento a questo prodotto
        if (otherItem.properties && 
            otherItem.properties['Componente'] === 'Diamante' &&
            otherItem.properties['Abbinato_a'] && 
            otherItem.properties['Abbinato_a'].includes(currentTitle)) {
            
            return {
                isBundle: true,
                associatedItem: otherItem,
                associatedIndex: i + 1, // line number
                currentRole: 'Montatura'
            };
        }
        
        // Se l'altro item è una montatura che fa riferimento a questo prodotto
        if (otherItem.properties && 
            otherItem.properties['Componente'] === 'Montatura' &&
            otherItem.properties['Abbinato_a'] && 
            otherItem.properties['Abbinato_a'].includes(currentTitle)) {
            
            return {
                isBundle: true,
                associatedItem: otherItem,
                associatedIndex: i + 1, // line number
                currentRole: 'Diamante'
            };
        }
    }
    
    return { isBundle: false };
}


// Funzione per intercettare eventi del drawer - VERSIONE MIGLIORATA
function interceptDrawerEvents() {
    console.log('Configurazione intercettazione eventi drawer migliorata...');
    
    // Intercetta TUTTI gli eventi del carrello wpbingo
    $(document).on('drawer.open drawer.footer cart:refresh', function() {
        console.log('Evento carrello rilevato - controllo quantità bundle');
        setTimeout(handleBundleQuantities, 300);
    });
    
    // Intercetta gli aggiornamenti del carrello AJAX
    let originalAjax = $.ajax;
    $.ajax = function(options) {
        let result = originalAjax.apply(this, arguments);
        
        // Se è una chiamata al carrello, intercetta il successo
        if (options.url && (options.url.includes('/cart') || options.url.includes('change.js'))) {
            result.done(function() {
                console.log('Chiamata AJAX carrello completata - controllo bundle');
                setTimeout(handleBundleQuantities, 400);
            });
        }
        
        return result;
    };
    
    // Observer migliorato per il DOM
    const cartObserver = new MutationObserver(function(mutations) {
        let shouldRecheck = false;
        
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                // Controlla se sono stati aggiunti elementi del carrello
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        if (node.classList && (
                            node.classList.contains('ajaxcart__product') ||
                            node.classList.contains('item-cart') ||
                            node.querySelector('.ajaxcart__product') ||
                            node.querySelector('.item-cart')
                        )) {
                            shouldRecheck = true;
                        }
                    }
                });
            }
        });
        
        if (shouldRecheck) {
            console.log('DOM del carrello modificato - controllo bundle');
            setTimeout(handleBundleQuantities, 200);
        }
    });
    
    // Osserva più container
    const targets = ['.js-drawer', '[data-cartpage-container]', '.ajaxcart__inner', '.page-cart'];
    targets.forEach(selector => {
        const element = document.querySelector(selector);
        if (element) {
            cartObserver.observe(element, { 
                childList: true, 
                subtree: true 
            });
            console.log('Observer configurato per:', selector);
        }
    });
    
    // Controllo periodico più aggressivo
    setInterval(function() {
        // Controlla se ci sono bundle senza i nostri controlli
        const bundleLines = [];
        
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                cart.items.forEach((item, index) => {
                    if (isBundleItemGlobal(item)) {
                        const line = index + 1;
                        const hasMessage = document.querySelector(`.bundle-qty-message[data-line="${line}"]`);
                        const hasVisibleQty = document.querySelector(`.ajaxcart__product[data-line="${line}"] .ajaxcart__qty:not([style*="none"]), .item-cart[data-line="${line}"] .quantity-content:not([style*="none"])`);
                        
                        if (!hasMessage || hasVisibleQty) {
                            bundleLines.push(line);
                        }
                    }
                });
                
                if (bundleLines.length > 0) {
                    console.log('Trovati bundle senza controlli:', bundleLines);
                    handleBundleQuantities();
                }
            })
            .catch(() => {}); // Ignora errori silenziosamente
    }, 1000);
}

// Intercetta click diretti sui controlli quantità
function interceptQuantityClicks() {
    console.log('Configurazione intercettazione click quantità...');
    
    // Intercetta click sui bottoni + e - 
    $(document).on('click', '.ajaxcart__qty-adjust, .js-qty-adjust', function(e) {
        const $product = $(this).closest('.ajaxcart__product, .item-cart');
        const line = $product.data('line');
        
        if (line) {
            // Controlla se è un bundle
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    const item = cart.items[line - 1];
                    if (item && isBundleItemGlobal(item)) {
                        console.log('Tentativo di modificare quantità bundle - BLOCCATO');
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        
                        // Riapplica controlli dopo un breve delay
                        setTimeout(() => hideBundleQuantityControls(line), 100);
                        
                        return false;
                    }
                })
                .catch(() => {});
        }
    });
    
    // Intercetta cambiamenti diretti negli input
    $(document).on('change input', '.ajaxcart__qty-num, .js-qty-number', function(e) {
        const $product = $(this).closest('.ajaxcart__product, .item-cart');
        const line = $product.data('line');
        
        if (line) {
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    const item = cart.items[line - 1];
                    if (item && isBundleItemGlobal(item)) {
                        console.log('Tentativo di modificare input quantità bundle - RIPRISTINATO');
                        $(this).val('1'); // Forza valore 1
                        e.preventDefault();
                        return false;
                    }
                })
                .catch(() => {});
        }
    });
    // AGGIUNGI QUESTO CODICE PRIMA DELLA CHIUSURA DELLA FUNZIONE
    
    // Intercetta click nella modale edit
    $(document).on('click', '.edit_variant-cart-container .js-qty-adjust', function(e) {
        console.log('Click su controllo quantità nella modale edit');
        
        const productTitle = $('.edit_variant-cart-container h3').text();
        
        // Controlla se è un bundle
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const bundleItem = cart.items.find(item => 
                    item.product_title === productTitle && isBundleItemGlobal(item)
                );
                
                if (bundleItem) {
                    console.log('Tentativo di modificare quantità bundle nella modale - BLOCCATO');
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    
                    // Ripristina valore 1
                    $(this).siblings('input').val('1');
                    
                    return false;
                }
            })
            .catch(() => {});
    });
    
    // Intercetta cambiamenti input nella modale edit
    $(document).on('change input', '.edit_variant-cart-container input[type="text"], .edit_variant-cart-container input[type="number"]', function(e) {
        const productTitle = $('.edit_variant-cart-container h3').text();
        
        if ($(this).attr('name') && $(this).attr('name').includes('quantity')) {
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    const bundleItem = cart.items.find(item => 
                        item.product_title === productTitle && isBundleItemGlobal(item)
                    );
                    
                    if (bundleItem) {
                        console.log('Tentativo di modificare input quantità bundle nella modale - RIPRISTINATO');
                        $(this).val('1');
                        e.preventDefault();
                        return false;
                    }
                })
                .catch(() => {});
        }
    });

}

// Intercetta modale di modifica prodotto
function interceptEditModal() {
    console.log('Configurazione intercettazione modale modifica...');
    
    // Intercetta apertura modale edit variants
    $(document).on('click', '.cart-product-edit_variant', function() {
        const productHandle = $(this).data('handle');
        console.log('Modale edit aperta per:', productHandle);
        
        // Aspetta che la modale si carichi e poi controlla
        setTimeout(function() {
            checkEditModalForBundles();
        }, 500);
    });
    
    // Observer per la modale edit
    const editModalObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1 && 
                        (node.classList.contains('edit_variant-cart-container') ||
                         node.querySelector('.edit_variant-cart-container'))) {
                        console.log('Modale edit rilevata nel DOM');
                        setTimeout(checkEditModalForBundles, 200);
                    }
                });
            }
        });
    });
    
    // Osserva il body per l'aggiunta della modale
    editModalObserver.observe(document.body, { 
        childList: true, 
        subtree: true 
    });
}

function checkEditModalForBundles() {
    console.log('Controllo se la modale edit contiene bundle...');
    
    const editModal = document.querySelector('.edit_variant-cart-container');
    if (!editModal) {
        console.log('Modale edit non trovata');
        return;
    }
    
    // Cerca informazioni sul prodotto nella modale
    const productTitle = editModal.querySelector('.product-edit_variants h3');
    const quantityInputs = editModal.querySelectorAll('input[type="text"], input[type="number"]');
    const quantityButtons = editModal.querySelectorAll('.js-qty-adjust, .ajaxcart__qty-adjust');
    
    if (productTitle) {
        const title = productTitle.textContent;
        console.log('Prodotto nella modale:', title);
        
        // Controlla nel carrello se questo prodotto è un bundle
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const bundleItem = cart.items.find(item => 
                    item.product_title === title && isBundleItemGlobal(item)
                );
                
                if (bundleItem) {
                    console.log('*** BUNDLE RILEVATO NELLA MODALE EDIT ***');
                    
                    // Disabilita tutti i controlli quantità nella modale
                    quantityInputs.forEach(input => {
                        if (input.name && input.name.includes('quantity')) {
                            input.value = '1';
                            input.disabled = true;
                            input.style.opacity = '0.5';
                            input.style.cursor = 'not-allowed';
                            input.title = getTranslation('fixed_quantity_tooltip');
                            console.log('Input quantità disabilitato nella modale');
                        }
                    });
                    
                    quantityButtons.forEach(button => {
                        button.disabled = true;
                        button.style.opacity = '0.5';
                        button.style.cursor = 'not-allowed';
                        button.title = getTranslation('fixed_quantity_tooltip');
                        console.log('Bottone quantità disabilitato nella modale');
                    });
                    
                    // Aggiungi messaggio nella modale
                    const quantityContainer = editModal.querySelector('.modalcart__quantity');
                    if (quantityContainer && !quantityContainer.querySelector('.bundle-qty-message-modal')) {
                        const message = document.createElement('div');
                        message.className = 'bundle-qty-message-modal';
                        message.innerHTML = `<small style="color: #666; font-style: italic; display: block; text-align: center; margin-top: 10px;">${getTranslation('fixed_quantity_tooltip')}</small>`;
                        quantityContainer.appendChild(message);
                        console.log('Messaggio aggiunto alla modale');
                    }
                } else {
                    console.log('Non è un bundle nella modale');
                }
            })
            .catch(error => {
                console.error('Errore controllo bundle modale:', error);
            });
    }
}


// Aggiungiamo gli stili CSS
const bundleStyles = `
<style>


.bundle-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.3s ease;
}

.bundle-modal-content {
    background: white;
    border-radius: 12px;
    max-width: 500px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    animation: slideIn 0.3s ease;
}

.bundle-modal-header {
    padding: 24px 24px 16px 24px;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.bundle-modal-header h3 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #000000;
}

.bundle-modal-close {
    background: none;
    border: none;
    font-size: 28px;
    cursor: pointer;
    color: #999;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
}

.bundle-modal-close:hover {
    background: #f5f5f5;
    color: #333;
}

.bundle-modal-body {
    padding: 24px;
}

.bundle-modal-body p {
    margin: 0 0 20px 0;
    color: #766f70;
    line-height: 1.3;
    font-size: 14px;
}

.bundle-items-preview {
    border: 2px solid #f0f0f0;
    border-radius: 8px;
    padding: 16px;
    background: #fafafa;
}

.bundle-item {
    display: flex;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #e5e5e5;
}

.bundle-item:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.bundle-item:first-child {
    padding-top: 0;
}

.bundle-item img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 8px;
    margin-right: 16px;
    border: 2px solid #ddd;
}

.bundle-item-info h4 {
    margin: 0 0 6px 0;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
}

.bundle-item-info p {
    margin: 0;
    font-size: 14px;
    color: #777;
}

.bundle-modal-footer {
    padding: 0px 24px 24px 24px;
    display: flex;
    gap: 12px;
    justify-content: flex-end;
}

.bundle-btn {
    padding: 12px 30px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
    letter-spacing:1.7px;
    text-transform: uppercase;
}

.bundle-btn-cancel {
    background: #f8f9fa;
    color: #000000;
    border: 2px solid #000000;
}

.bundle-btn-cancel:hover {
    background: #e9ecef;
    color: #000000;
}

.bundle-btn-confirm {
    background: #5c1f29;
    color: white;
    border: 2px solid #5c1f29;
}

.bundle-btn-confirm:hover {
    background: #6c353e;
    border-color: #6c353e;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes slideIn {
    from { transform: scale(0.9) translateY(-20px); opacity: 0; }
    to { transform: scale(1) translateY(0); opacity: 1; }
}

@media (max-width: 768px) {
    .bundle-modal-content {
        width: 95%;
        margin: 20px;
    }
    
    .bundle-modal-footer {
        flex-direction: column;
    }
    
    .bundle-btn {
        width: 100%;
        justify-content: center;
    }
}
</style>
`;

// Aggiungiamo gli stili al head
document.head.insertAdjacentHTML('beforeend', bundleStyles);